import { Injectable } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics'; // Updated import
import { CurrentUser } from '@app/models';
import { CommonService } from './common.service';
import { sanitizeAnalyticsEventParams } from './analytics/analytics-sanitizer';
import * as _moment from 'moment-timezone';

const moment = _moment;

@Injectable({
  providedIn: 'root'
})
export class AnalyticService {

  constructor(
    private readonly _analytics: AngularFireAnalytics,
    private readonly _commonService: CommonService
  ) { }

  setCurrentScreen(value: string) {
    this._analytics.setCurrentScreen(value);
  }

  logAnalyticEvent(eventName: string, eventParams?: { [key: string]: any; } | undefined) {
    const sanitizedParams = sanitizeAnalyticsEventParams(eventParams);
    this._analytics.logEvent(
      eventName,
      {
        ...sanitizedParams, 
        'date_timestamp': moment().utc().format()
      }
    );
  }

  /**
   * Tracks search performed analytics event
   * @param eventName The analytics event name to log
   * @param isSearch Whether this is a search query
   * @param searchQuery The search query text
   * @param searchBy The search filter/field being searched
   * @param resultsCount The number of results returned
   * @param page The current page number (only tracks on page 1)
   * @param isRefresh Whether this is a refresh operation (optional)
   * @param includeSearchPerformed Whether to include 'search_performed: true' in params (optional, default: true)
   */
  trackSearchPerformed(
    eventName: string,
    isSearch: boolean,
    searchQuery: string,
    searchBy: string,
    resultsCount: number,
    page: number,
    isRefresh: boolean = false,
    includeSearchPerformed: boolean = true
  ): void {
    if (isSearch && searchQuery && page === 1 && !isRefresh) {
      const eventParams: { [key: string]: any } = {
        'search_query': searchQuery,
        'results_count': resultsCount,
        'search_by': searchBy
      };
      
      if (includeSearchPerformed) {
        eventParams['search_performed'] = true;
      }
      
      this.logAnalyticEvent(eventName, eventParams);
    }
  }

  // Google Anayltics - Set users details 
  setAnalytics(userData: CurrentUser | null) {
    if (!userData) {
      this._analytics.setUserId('');
      this._analytics.setUserProperties({});
    }
    else {
      this._analytics.setUserId(userData.user.user_id || '');
      this._analytics.setUserProperties({
        'portal_user_id': userData.user.user_id || '',
        'portal_user_role': userData.user.role,
        'portal_user_hasFullAccess': userData.user.hasFullAccess,
        'portal_user_active': userData.user.active,
        'portal_user_default_org_id': userData.user.default_org
      });
      this._analytics.setAnalyticsCollectionEnabled(true);
    }
  }

  get userData(): CurrentUser | null {
    return this._commonService.appProfileDataAsValue?.user;
  }

}